// Date de la dernière mise à jour réelle du site (à mettre à jour manuellement à chaque mise en production).
export const LastUpdated = '14 Octobre 2026';
